import translations from './translations.json';

export default key => {
  const { mssp } = window;
  const language =
    mssp && mssp.application.language ? mssp.application.language : 'ptbr';
  return translations[key] ? translations[key][language] || key : key;
};
